import {
  Award,
  Shirt,
  Layers3,
  ShoppingBag,
  HardHat,
  Bath,
  Heart,
} from "lucide-react";

const services = [
  {
    icon: Award,
    title: "Bordir Logo",
    desc: "Logo perusahaan, komunitas, atau brand pribadi dengan detail tajam dan warna konsisten.",
  },
  {
    icon: Shirt,
    title: "Seragam Kantor",
    desc: "Seragam kerja, instansi, atau event dengan jahitan presisi yang tahan cuci berulang.",
  },
  {
    icon: Layers3,
    title: "Kemeja & Polo",
    desc: "Bordir di dada, lengan, atau punggung. Cocok untuk merchandise dan dress code tim.",
  },
  {
    icon: ShoppingBag,
    title: "Kaos Custom",
    desc: "Bordir di kaos katun maupun cotton combed. Tampil lebih premium dibanding sablon biasa.",
  },
  {
    icon: HardHat,
    title: "Topi & Jaket",
    desc: "Bordir topi snapback, trucker, hingga jaket varsity dengan posisi simetris dan rapi.",
  },
  {
    icon: Bath,
    title: "Handuk Hotel & Spa",
    desc: "Bordir nama brand pada handuk dengan teknik khusus agar serat tetap lembut dan kuat.",
  },
  {
    icon: Heart,
    title: "Boneka & Souvenir",
    desc: "Personalisasi boneka, tas, atau souvenir untuk hadiah, event, dan kebutuhan promosi.",
  },
  {
    icon: Layers3,
    title: "Custom Lainnya",
    desc: "Punya media unik? Konsultasikan, tim kami akan bantu mencarikan teknik bordir terbaik.",
    highlight: true,
  },
];

export default function Services() {
  return (
    <section
      id="layanan"
      data-testid="services-section"
      className="py-20 md:py-28 bg-background relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-xs sm:text-sm uppercase tracking-[0.25em] font-semibold text-primary">
            Layanan Bordir
          </span>
          <h2
            data-testid="services-headline"
            className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-semibold text-foreground"
          >
            Hampir semua media bisa kami bordir.
          </h2>
          <p className="mt-4 font-body text-base md:text-lg text-muted-foreground leading-relaxed">
            Dari kain tipis hingga material tebal, mesin komputer kami sudah
            terkalibrasi untuk berbagai jenis bahan dengan hasil yang konsisten.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {services.map((s, idx) => (
            <div
              key={idx}
              data-testid={`service-card-${idx}`}
              className={`group p-7 rounded-xl border transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${
                s.highlight
                  ? "bg-primary text-primary-foreground border-primary"
                  : "bg-secondary border-border hover:border-primary/40"
              }`}
            >
              <div
                className={`w-12 h-12 rounded-lg flex items-center justify-center mb-5 ${
                  s.highlight ? "bg-white/15" : "bg-background"
                }`}
              >
                <s.icon
                  className={`w-6 h-6 ${
                    s.highlight ? "text-white" : "text-primary"
                  }`}
                />
              </div>
              <h3
                className={`font-heading text-lg sm:text-xl font-semibold ${
                  s.highlight ? "text-white" : "text-foreground"
                }`}
              >
                {s.title}
              </h3>
              <p
                className={`mt-2 font-body text-sm leading-relaxed ${
                  s.highlight ? "text-white/85" : "text-muted-foreground"
                }`}
              >
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
